import { useState, useRef, useEffect } from "react";

// Campo di ricerca con suggerimenti: scrivi il nome e ti propone tutti quelli
// che lo contengono. Se non esiste e onCreate è fornito, mostra "Crea «testo»".
export default function Autocomplete({ items = [], placeholder, onSelect, onCreate, initialText = "", createLabel = "Crea", testid }) {
  const [text, setText] = useState(initialText);
  const [open, setOpen] = useState(false);
  const boxRef = useRef(null);

  useEffect(() => { setText(initialText); }, [initialText]);
  useEffect(() => {
    const h = (e) => { if (boxRef.current && !boxRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  const q = text.trim().toLowerCase();
  const matches = q ? items.filter((it) => (it.label || "").toLowerCase().includes(q)) : items;
  const exact = items.some((it) => (it.label || "").toLowerCase() === q);
  const pick = (it) => { setText(it.label); setOpen(false); onSelect && onSelect(it); };
  const create = () => { setOpen(false); onCreate && onCreate(text.trim()); };

  return (
    <div className="ac" ref={boxRef}>
      <input value={text} placeholder={placeholder} data-testid={testid} autoComplete="off"
        onChange={(e) => { setText(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} />
      {open && (matches.length > 0 || (onCreate && q && !exact)) && (
        <div className="ac-list" data-testid={testid ? `${testid}-list` : undefined}>
          {matches.slice(0, 60).map((it) => (
            <div key={it.id} className="ac-item" data-testid={testid ? `${testid}-opt-${it.id}` : undefined} onMouseDown={() => pick(it)}>
              {it.label}{it.sub && <span className="muted" style={{ marginLeft: 6, fontSize: 12 }}>{it.sub}</span>}
            </div>
          ))}
          {onCreate && q && !exact && (
            <div className="ac-item ac-create" data-testid={testid ? `${testid}-create` : undefined} onMouseDown={create}>
              ➕ {createLabel} «{text.trim()}»
            </div>
          )}
        </div>
      )}
    </div>
  );
}
